<template>
    <div id="forgot-password">
        <div class="page animation vertical-align text-center forgot-your-pass" data-animation-in="fade-in" data-animation-out="fade-out">
            <div class="page-content vertical-align-middle" style="display: block;">

                <div class="brand">
                    <a href="http://www.trackado.com"><img class="brand-img" src="/Assets/landing/logo-landing.png" /></a>
                </div>

                <form v-if="!showSuccessMsg" @submit.prevent="onResetPassword" id="reset-password-wrapper">
                    <div class="login-page-title">
                        Forgot your Password?
                    </div>
                    <div class="login-page-description">
                        Please enter your registered email address below to start your password reset.
                    </div>
                    <div class="reset-password-form">
                        <div class="form-group form-material inp-error-marker">
                            <v-input-text :type="text"
                                          :label="'EMAIL'"
                                          :placeholder="'Email'"
                                          :value="firstName"
                                          @input="(val) => (email = val)"
                                          @focus="validation.forEmail = false"
                                          :required="true"
                                          :showError="validation.forEmail"
                                          :errorMessage="emailErrorMsg"></v-input-text>
                        </div>

                        <!-- Friendly captcha -->
                        <div id="friendly-captcha"></div>

                        <div class="form-group">
                            <button v-if="!resetPasswordSubmited" id="reset-pass-btn" type="submit" class="btn btn-success btn-block login-btn" :disabled="isDisabled">RESET YOUR PASSWORD</button>
                            <button v-if="resetPasswordSubmited" id="reset-pass-btn-loader" type="button" class="btn btn-success btn-block login-btn" hidden><img style="margin-top: -40px;" class="loader-icon-gif" src="/Assets/loader.gif" /></button>
                        </div>
                    </div>
                </form>

                <div v-if="showSuccessMsg" id="reset-password-success-msg">
                    <div class="check-inbox">
                        <img src="/Assets/landing/icon-mail.png" />
                    </div>
                    <div class="login-page-title password-changed">
                        Please check your inbox!
                    </div>
                    <div class="login-page-description password-changed">
                        If we found an account associated with your email address you should receive an email shortly with further instructions.
                    </div>
                    <div class="login-page-description password-changed">
                        If the email is not in your inbox please make sure to check your spam folder. Thanks!
                    </div>
                </div>
                <div class="friendly-captcha-forgot-pass">
                    <p>This site is protected by <a href="https://friendlycaptcha.com/" target="_blank">Friendly Captcha</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "forgot-password",
        components: {

        },
        data: () => {
            return {
                email: "",
                resetPasswordSubmited: false,
                showSuccessMsg: false,
                isDisabled: false,
                emailErrorMsg: "",
                validation: {
                    forEmail: false
                }

            }
        },
        methods: {
            onResetPassword() {
                if (this.isValidForm()) {
                    gtagex('event', 'password_reset_form_submitted', { event_category: "Password Reset", event_label: "Password Reset" });
                    this.resetPasswordSubmited = true;

                    var model = {
                        Email: this.email,
                        CaptchaToken: window.friendlyChallenge.solution
                    };
                    app.api.UserProfile.sendResetPasswordEmail(model, this.onResetPasswordSucces, this.onResetPasswordError);
                }
            },

            onResetPasswordSucces() {
                this.showSuccessMsg = true;
            },

            onResetPasswordError() {
                if (window.friendlyChallenge.customWidget) {
                    window.friendlyChallenge.customWidget.reset();
                    this.isDisabled = true
                }
                //this.resetPasswordSubmited = false;
                this.showSuccessMsg = true;
            },

            isValidForm() {
                var valid = app.Validation;
                var isValid = true;

                if (valid.isEmptyTextVal(this.email)) {
                    this.emailErrorMsg = "*Please insert email.";
                    isValid = false;
                    this.validation.forEmail = true;
                }

                if (!valid.isEmptyTextVal(this.email)) {
                    if (!valid.isValidEmailValue(this.email)) {
                        this.emailErrorMsg = "*Please insert valid email.";
                        isValid = false;
                        this.validation.forEmail = true;
                    }
                }

                return isValid;
            },
        }
    };
</script>

<style scoped>

    .validation-error {
        color: #ee653b;
        font-family: "proxima-nova";
        font-size: 12px;
        font-weight: bold;
        display: block;
        top: 14px;
        right: 45px;
    }

    .floating-label {
        padding-left: 2px !important;
    }

    #reset-password-success-msg {
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?2552cf15